"use client";
import { font_title_secularOne } from "@/app/ui/fonts";
import NumberTicker from "@/app/ui/magicui/number-ticker";
import { SeasonStats, SingleStat as SingleStatType } from "@/data/stats";
import { cn } from "@/lib/utils";
import useSWR from 'swr';



export default function NfStatsClient({ stats }: { stats: SeasonStats }) {
    const { data } = useSWR(stats.comments ? '/api/stats' : null, {
        revalidateOnMount: false,
        fallbackData: stats,
    })
    const s = data as SeasonStats;

    return <>
        <SingleStat stat={ getValWithGrow(s, s.views) } text="צפיות" />
        <SingleStat stat={ getValWithGrow(s, s.likes) } text="לייקים" />
        <SingleStat stat={ getValWithGrow(s, s.comments) } text="תגובות" />
        <SingleStat stat={ getValWithGrow(s, s.duration) } text="זמן צפייה" />
    </>

}

export function SingleStat({ stat, text, className }: { stat: number, text: string, className?: string }) {
    let sign;
    let readableStat = stat + 0;
    if (stat >= 1000000) {
        sign = <span className="text-xs font-black tracking-wider">מיליון</span>
        readableStat = stat / 1000000
    }

    return <div className={ cn("flex md:max-lg:flex-col flex-wrap items-center justify-center lg:px-4 rounded py-1 sm:py-4 bg-black/10 backdrop-blur-md text-shadow-sm border-2 border-nfPurple-500 gap-x-3 gap-y-0",
        className) }>
        <div className="text-shadow-md text-shadow-black/30">
            <NumberTicker value={ (readableStat || 0) } decimalPlaces={ sign && 2 || 0 } className={ "text-2xl" } />{ sign }
        </div>
        <span className={ cn("leading-none whitespace-nowrap", font_title_secularOne.className, "text-3xl") }>{ text }</span>
    </div>
}

function getValWithGrow(s: SeasonStats, stat: SingleStatType | undefined) {
    if (!stat)
        return 0;

    const timeDiff = (Date.now() - s.lastUpdate) / 1000;
    return stat.val + ~~(stat.grow * timeDiff)
}